import {FileRead, FileType} from "@bounce/shared/declarations";
import {appendUrlParams} from "@bounce/shared/helpers";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {AxiosResponse} from "axios";
import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";

type Variables = {
  accountId: string | undefined;
  excludeFiles?: FileType[];
  includeFiles?: FileType[];
  fileIds?: string[];
  tab?: string;
};
type Data = FileRead[];

export const getUserFiles = async (variables: Variables): Promise<Data> => {
  if (!variables.accountId) {
    // @ts-ignore
    return;
  }
  const appendedQueryParams = appendUrlParams({
    excludeFiles: variables.excludeFiles,
    includeFiles: variables.includeFiles,
    fileIds: variables.fileIds,
  });

  const result = await axiosConsumerAppInstance.get<Data, AxiosResponse<Data>>(
    `/files/${variables.accountId}${appendedQueryParams}`
  );
  return result.data;
};

export const useGetUserFilesQuery = (
  variables: Variables,
  options?: BaseQueryOptions<Data, Variables>
): BaseUseQueryResult<Data> => {
  return useBaseQuery<Data, Variables>(
    ["user", "files", variables.tab, variables.accountId],
    getUserFiles,
    variables,
    options
  );
};
